<template>
  <div style="margin: 0 48px 8px 24px;">
    <el-form ref="formRef" :model="caseForm" label-width="auto" label-position="right">
      <el-form-item label="发布状态：" v-if="type == 2">
        <el-select v-model="anonymous" placeholder="Select" style="width: 10em">
          <el-option v-for="item in anonymousArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="情况描述：">
        <el-input type="textarea" :rows="6" v-model="caseForm.content" placeholder="请简单描述情况" />
      </el-form-item>
      <el-form-item :label="type==1?'名称：':'宠物名称：'" v-if="anonymous == 0">
        <el-input v-model="petName" placeholder="请输入名称" />
      </el-form-item>
      <el-form-item label="宠物类型：">
        <el-select v-model="petType" placeholder="Select" class="select-item" @change="petTypeChange">
          <el-option v-for="item in petTypeArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="品种：" v-if="type == 2">
        <el-select v-model="breedId" placeholder="Select" style="width: 22em" @change="breedIdChange" filterable>
          <el-option v-for="item in breedIdArray" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="花色：" v-if="type == 2 && petType == 1">
        <el-select v-model="breedColorId" placeholder="Select" style="width: 22em">
          <el-option v-for="item in breedColorIdArray" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="性别：">-->
<!--        <el-radio v-model="type" :label="1">弟弟</el-radio>-->
<!--        <el-radio v-model="type" :label="2">妹妹</el-radio>-->
<!--      </el-form-item>-->
      <el-form-item label="年龄：" v-if="type == 2">
        <div style="display: flex;">
          <el-select v-model="age" placeholder="Select" style="width: 6em">
            <el-option v-for="item in ageArray" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
          &nbsp;&nbsp;岁&nbsp;&nbsp;
          <el-select v-model="month" placeholder="Select" style="width: 6em">
            <el-option v-for="item in monthArray" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
          &nbsp;&nbsp;月
        </div>
      </el-form-item>
      <el-form-item label="总共花费：" v-if="type == 2">
        <el-input v-model="payExpense" placeholder="请输入金额"/>
      </el-form-item>
      <el-form-item label="获得报销：" v-if="type == 2">
        <el-input v-model="claimExpense" placeholder="请输入金额"/>
      </el-form-item>
      <el-form-item label="发布日期：">
        <el-date-picker
            v-model="pushTime"
            type="datetime"
            placeholder="请选择发布日期"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="头像：" v-if="anonymous == 0">
        <div>
          <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 80px;height: 80px;margin: 0">
          <div class="add" @click="headImgUpdate" v-else>
            <span>+</span>
          </div>
          <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" style="display:none;">
        </div>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" :disabled="loading" v-loading="loading" >确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData, imgPostFormData } from "@/api/api"
import { addOrUpdateMedicalCase, getAllPetBreedList, addMedicalCaseImg, delMedicalCaseImg} from "@/api/url";
import { phoneReg, greaterIntReg } from "@/assets/shared/reg-constant";
import ImgViewer from "@/assets/js/imageViewer";

export default {
  name: "BannerDialog",
  props: {
    value: Object
  },
  data() {
    return {
      caseForm: this.value.caseForm,
      idx: this.value.ids,
      type: this.value.type,

      files: null,
      src: this.value.caseForm.headImg,
      loading: false,
      //
      // imgArray: this.value.caseForm.imgList?this.value.caseForm.imgList:[],
      // delImgIdArray: [],

      petName: this.value.caseForm.petName?this.value.caseForm.petName:this.value.type == 1?'平台':'',

      petTypeArray: [
        {label: '猫', value: 1},
        {label: '狗', value: 2}
      ],
      petType: this.value.caseForm.petType?this.value.caseForm.petType:1,
      anonymous: this.value.caseForm.anonymous?this.value.caseForm.anonymous:0,
      anonymousArray: [
        {label: '公开', value: 0},
        {label: '匿名', value: 1}
      ],

      breedIdArray: [],
      breedId: this.value.caseForm.petBreedId,

      breedColorIdArray: [],
      breedColorId: this.value.caseForm.petBreedColorId,

      allPetBreedList: [],

      pushTime: this.value.caseForm.pushTime,
      ageArray: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      age: this.value.caseForm.age?this.value.caseForm.age:0,
      monthArray: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      month: this.value.caseForm.month?this.value.caseForm.month:0,

      avater: require('/src/assets/image/avatar_adopt.jpg'),

      payExpense: this.value.caseForm.payExpense?this.value.caseForm.payExpense:'',
      claimExpense: this.value.caseForm.claimExpense?this.value.caseForm.claimExpense:'',

    }
  },
  methods: {

    showImg(idx) {
      let imgList = []
      for(let i=0; i<this.imgArray.length; i++) {
        imgList.push(this.imgArray[i].img)
      }
      ImgViewer.open({
        imgList: imgList,
        imgIndex: idx
      })
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    // //更改或添加
    // fileUpdate() {
    //   this.$refs.file.setAttribute('type', 'file')
    //   this.$refs.file.click();
    // },
    //
    // //选取图片
    // fileChanged(e) {
    //   if(e.target.files[0]) {
    //     for(let item of e.target.files) {
    //       let windowURL = window.URL || window.webkitURL;
    //       let src = windowURL.createObjectURL(item);
    //       let obj = {'img': src, 'smallImg': src, 'files': item};
    //       if(this.imgArray.length < 9) {
    //         this.imgArray.push(obj);
    //       }
    //     }
    //     this.$refs.file.setAttribute('type', 'text')
    //   }
    // },
    //
    // // 删除图片
    // delImg(idx) {
    //   if(this.imgArray[idx].id >= 0) {
    //     this.delImgFrom(idx);
    //   }
    //   this.imgArray.splice(idx,1);
    // },

    petTypeChange(val) {
      this.breedIdArray = this.allPetBreedList.filter(item => item.type == val)
      this.breedColorIdArray = this.breedIdArray[0].petBreedColorList
      this.breedId = this.breedIdArray[0].id
      if(val == 1) {
        this.breedColorId = this.breedColorIdArray[0].id
      }

    },

    breedIdChange(val) {
      this.breedColorIdArray = []
      for(let i=0; i<this.breedIdArray.length; i++) {
        if(val == this.breedIdArray[i].id) {
          this.breedColorIdArray = this.breedIdArray[i].petBreedColorList
          this.breedColorId = this.breedIdArray[i].petBreedColorList[0].id
        }
      }
    },

    getAllPetList() {
      getFormData(getAllPetBreedList).then(data => {
        let {msg, code} = data
        if (code == 200) {
          this.allPetBreedList = data.data
          this.breedIdArray = data.data.filter(item => item.type == this.petType)
          if(this.breedId) {
            for(let i=0; i<this.breedIdArray.length; i++) {
              if(this.breedId == this.breedIdArray[i].id) {
                this.breedColorIdArray = this.breedIdArray[i].petBreedColorList
              }
            }
          }else {
            this.breedColorIdArray = this.breedIdArray[0].petBreedColorList
            this.breedId = this.breedIdArray[0].id
            this.breedColorId = this.breedColorIdArray[0].id
          }
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.caseForm.content) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先输入情况描述',
          type: 'warning'
        });
        return false
      }
      if(!this.petName && this.anonymous == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先输入名称',
          type: 'warning'
        });
        return false
      }
      if(!this.pushTime) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择发布时间',
          type: 'warning'
        });
        return false
      }
      if(!this.src && this.anonymous == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请上传头像',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = new FormData();
      param.append('id', this.idx > -1?this.caseForm.id:0);
      param.append('type', this.type);
      param.append('petType', this.petType);
      param.append('anonymous', this.anonymous);
      if(this.type == 2) {
        param.append('petBreedId', this.breedId);
        param.append('petBreedColorId', this.petType == 1?this.breedColorId:0);
        param.append('payExpense', this.payExpense?this.payExpense:0);
        param.append('claimExpense', this.claimExpense?this.claimExpense:0);
        param.append('age', this.age);
        param.append('month', this.month);
      }
      param.append('petName', this.petName);
      param.append('content', this.caseForm.content);
      param.append('pushTime', this.pushTime);
      param.append('file', this.files);

      imgPostFormData(addOrUpdateMedicalCase, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      })
    },

    imageUrlToBase64(imageUrl) {
      let image = new Image() // 一定要设置为let，不然图片不显示
      image.setAttribute('crossOrigin', 'anonymous') // 解决跨域问题
      // image.src = imageUrl +"&v=" + Math.random() // 如果是本地图片替换为 image.src = imageUrl
      image.src = imageUrl
      image.onload = () => {
        var canvas = document.createElement("canvas")
        canvas.width = image.width
        canvas.height = image.height
        var context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        var quality = 0.8
        var dataURL = canvas.toDataURL("image/jpeg", quality) // 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
        this.base64toFile(dataURL)
      }
    },

    base64toFile (dataurl, filename = 'file') {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let suffix = mime.split('/')[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }

      let file = new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
      console.log(file)
      this.files = file
    },


  },
  mounted() {
    if(this.type == 2) {
      this.getAllPetList()
    }
    if(this.type == 1 && !this.src && this.idx == -1) {
      this.src = this.avater
      this.imageUrlToBase64(this.avater)
    }
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  margin: 0 auto
}
.img-box {
  width: 80px;
  height: 80px;
  position: relative;
}
.delIcon {
  background-color: rgba(0,0,0,0.5);
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
